import React, { useContext } from 'react'
// import { Link } from 'react-router-dom'
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import Bg from '@images/footer.webp'
import pImg1 from '@images/instagram/instagram1.webp'
import pImg2 from '@images/instagram/instagram2.webp'
import pImg3 from '@images/instagram/instagram3.webp'
import pImg4 from '@images/instagram/instagram4.webp'
import pImg5 from '@images/instagram/instagram5.webp'
import pImg6 from '@images/instagram/instagram6.webp'
import CtaSection from '../CtaSection/CtaSection';
import { LanguageContext } from '../../index';

const images = [
    pImg1,
    pImg2,
    pImg3,
    pImg4,
    pImg5,
    pImg6,
]




const Footer = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const [open, setOpen] = React.useState(false);
    const { language } = useContext(LanguageContext);
    // Define translations for supported languages
    const translations = {
        pl: {
            contact: "Kontakt",
            address: "Adres: Kraków, ul. Zakopiańska 56 (lokal nr 24).",
            phone1: "Telefon: +48 506 708 825",
            email1: "e-mail: fabripodlogi@gmail.com",
            phone2: "Telefon: +48 538 368 480",
            email2: "e-mail: salonfabri@gmail.com",
            copyright: "© Copyright 2025 by Fabri"
        },
        en: {
            contact: "Contact",
            address: "Address: Kraków, ul. Zakopiańska 56 (unit 24).",
            phone1: "Phone: +48 506 708 825",
            email1: "e-mail: fabripodlogi@gmail.com",
            phone2: "Phone: +48 538 368 480",
            email2: "e-mail: salonfabri@gmail.com",
            copyright: "© Copyright 2025 by Fabri"
        }
    };

    const t = translations[language] || translations.pl;

    return (
        <div>
            { <CtaSection/> }
            <footer className="footer-section pt-220" style={{ backgroundImage: `url(${Bg})` }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-6 col-lg-8">
                            <div className="instagram-posts">
                                {images.map((item, pitem) => (
                                    <div className="instagram-item" key={pitem}>
                                        <img src={item} alt="Instagram" onClick={() => setOpen(true)} />
                                        <div className="instagram-overlay">
                                            <span onClick={() => setOpen(true)}><i className="fa fa-instagram"></i></span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-4">
                            <div className="contact-widget">
                                <h3>{t.contact}</h3>
                                <h6>{t.address}</h6><br/>
                                <h6>{t.phone1}</h6>
                                <h6 className='orangephone'>{t.email1}</h6><br/>
                                <h6>{t.phone2}</h6>
                                <h6>{t.email2}</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom mt-55">
                    <div className="container">
                        <div className="bottom-inner">
                            <div className="social-icons">
                                <a href="https://www.facebook.com/podlogifabri" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook"></i></a>
                                <a href="https://www.instagram.com/podlogifabri/" target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram"></i></a>
                                <a href="https://it.pinterest.com/search/pins/?q=podlogi%20fabri&rs=typed" target="_blank" rel="noopener noreferrer"><i className="fa fa-pinterest"></i></a>
                                <a href="https://www.youtube.com/@Fabri-podlogiischody" target="_blank" rel="noopener noreferrer"><i className="fa fa-youtube"></i></a>
                            </div>
                            <div className="copyright">
                                <p>{t.copyright}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <Lightbox
                    open={open}
                    close={() => setOpen(false)}
                    slides={[
                        { src: pImg1 },
                        { src: pImg2 },
                        { src: pImg3 },
                        { src: pImg4 },
                        { src: pImg5 },
                        { src: pImg6 },
                    ]}
                    plugins={[Zoom]}
                />
            </footer>
        </div>
    )
}

export default Footer;